import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  tabNode: {
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    gap: 5,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 5,
  },
  border: {
    borderBottomWidth: 3,
    // marginTop: 5,
    marginBottom: 15,
    borderRadius: 50,
  },
  redDot: {height: 5, width: 5, borderRadius: 10},
});
